
import { apiSlice } from "../apiSlice";


// Dashboard related interfaces
export interface SalesStat {
    date: string;
    totalSales: number;
}

export interface GetSalesDataResponse {
    salesStatList: SalesStat[];
}

export interface Transaction {
    transactionTag: string;
    createdAt: {
        _seconds: number;
        _nanoseconds: number;
    };
    amount: number;
    description: string;
    id: string;
    paymentMethod: string;
    type: string;
    mainTransactionId: string;
}
const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PROD;
export interface TransactionsResponse {
    transactionsList: {
        Refund: {
            totalAmount: number;
            transactions: Transaction[];
        };
        Earnings: {
            totalAmount: number;
            transactions: Transaction[];
        };
        MarketingSpend: {
            totalAmount: number;
            transactions: Transaction[];
        };
        CurryKingFees: {
            totalAmount: number;
            transactions: Transaction[];
        };
        CartCommissions: {
            totalAmount: number;
            transactions: Transaction[];
        };
        Sales: {
            totalAmount: number;
            transactions: Transaction[];
        };
        OtherPayments: {
            totalAmount: number;
            transactions: Transaction[];
        };
    };
}

export interface PaymentOrderStatsResponse {
    totalCounts: {
        allOrderCount: number;
        totalPayout: number;
        customerCount: number;
        customerRefunds:number
    };
}

export interface RefundOrder {
    refundRequestsList: {
        orderId: string;
        orderReference: string;
        description: string;
        requestedDate: string;
        status: string;
        requestedBy: string;
        customer: {
            userId: string;
            id: string;
        };
        createdAt: {
            _seconds: number;
            _nanoseconds: number;
        };
        id: string;
    }[];
}

export interface OrderRefunding {
    refundRequestId: string;
    status: string;
}

export const orderService = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getPaymentOrderStats: builder.query<PaymentOrderStatsResponse, { restaurantId: string; startDate: string; endDate: string }>({
            query: ({ restaurantId, startDate, endDate }) => {
                const url = `https://adminhttps-getpaymentorderstatsforrestaurant${API_BASE_DOMAIN}?restaurantId=${restaurantId}&startDate=${startDate}&endDate=${endDate}`;
                return {
                    url,
                    method: "GET",
                    responseHandler: (response) => response.json(),
                };
            },
        }),
        getSalesDataForRestaurant: builder.query<GetSalesDataResponse, { restaurantId: string; startDate: string; endDate: string }>({
            query: ({ restaurantId, startDate, endDate }) => {
                const url = `https://adminhttps-getsalesdataforrestaurant${API_BASE_DOMAIN}?restaurantId=${restaurantId}&startDate=${startDate}&endDate=${endDate}`;
                return {
                    url,
                    method: "GET",
                    responseHandler: (response) => response.json(),
                };
            },
        }),

        getTransactionsForRestaurant: builder.query<TransactionsResponse, { restaurantId: string; startDate: string; endDate: string }>({
            query: ({ restaurantId, startDate, endDate }) => {
                const url = `https://adminhttps-gettransactionsforrestaurant${API_BASE_DOMAIN}?restaurantId=${restaurantId}&startDate=${startDate}&endDate=${endDate}`;
                return {
                    url,
                    method: "GET",
                    responseHandler: (response) => response.json(),
                };
            },
        }),
        getRefundOrders: builder.query<RefundOrder, any>({
            query: ({ restaurantId, status }: any) => ({
                url: `https://adminhttps-getrefundrequests${API_BASE_DOMAIN}?restaurantId=${restaurantId}&status=${status}`,
                method: "GET",
                responseHandler: (response) => response.json(),
            }),
        }),
        orderRefunding: builder.mutation<any, OrderRefunding>({
            query: (data) => ({
                url: `https://adminhttps-processrefund${API_BASE_DOMAIN}`,
                method: "POST",
                body: data,
                responseHandler: (response) => response.json(),
            }),
        }),
    }),
});

export const {
    useGetPaymentOrderStatsQuery,
    useGetSalesDataForRestaurantQuery,
    useGetTransactionsForRestaurantQuery,
    useGetRefundOrdersQuery,
    useLazyGetRefundOrdersQuery,
    useOrderRefundingMutation
} = orderService;

